<template>
  <div>
    <v-alert
      v-if="absences.length > 0"
      :prominent="!$vuetify.breakpoint.xs"
      class="ma-0 rounded-t-0"
      icon="mdi-bed"
      color="danger"
      text
    >
      Du hast
      {{
        absences.length > 1
          ? absences.length + " offene Abwesenheiten"
          : absences.length + " offene Abwesenheit"
      }}!
    </v-alert>
    <v-alert
      v-if="justifications.length > 0"
      :prominent="!$vuetify.breakpoint.xs"
      class="ma-0 rounded-t-0"
      icon="mdi-bed"
      color="danger"
      text
    >
      Du hast
      {{
        justifications.length > 1
          ? justifications.length + " zurückgewiesene Entschuldigungen"
          : justifications.length + " zurückgewiesene Entschuldigung"
      }}!
    </v-alert>
    <v-card
      :class="`v-alert--text danger--text rounded-t-0`"
      flat
      tile
      :loading="loading"
    >
      <v-divider />
      <v-card-actions>
        <v-btn
          dark
          color="danger"
          text
          block
          small
          :to="{ name: 'StudentAbsences' }"
          >erledigen</v-btn
        ></v-card-actions
      >
    </v-card>
  </div>
</template>

<script>
import { defineComponent } from "vue";
export default defineComponent({
  data() {
    return {
      absences: [],
      justifications: [],
      loading: false,
    };
  },
  methods: {
    async fetchData() {
      this.loading = true;
      this.absences = await this.apiList({
        resource: "absence/absence",
        query: "pending",
      });
      if (this.absences.length > 0) {
        this.$emit("loaded");
      }
      this.justifications = await this.apiList({
        resource: "absence/justification",
        query: "status=pendingStudent&student=" + this.$_profilePerson.id,
      });
      if (this.justifications.length > 0) {
        this.$emit("loaded");
      }
      this.loading = false;
    },
  },
  created() {
    this.fetchData();
  },
});
</script>
